import React from 'react'
import PropTypes from 'prop-types'
import { Label } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'
import { statusColor, approveStatus } from '../helpers/color'
import * as CONSTANTS from '../constants'
import { FONTS } from '../../../constants'

export const MyTimesheet = (props) => {
  const { myTimesheet } = props
  const status = approveStatus(get(myTimesheet, 'timesheet.status'))
  const color = statusColor(get(myTimesheet, 'timesheet.status'))
  const submitedDate = get(myTimesheet, 'timesheet.submitedDate')
  const submitedDateString = submitedDate ? moment(submitedDate).format('DD/MM/YYYY') : '-'
  const approvedDate = get(myTimesheet, 'timesheetSubmitRequest.updated')
  const approvedDateString = approvedDate ? moment(approvedDate).format('DD/MM/YYYY') : '-'
  const remark = get(myTimesheet, 'timesheetSubmitRequest.remark_request_user')

  return (
    <Wrapper>
      <GroupLabel>
        <Title>Status:</Title>
        <Detail color={ color }>
          <Circle color={ color } />
          { status }
        </Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Submitted Date:</Title>
        <Detail>{ submitedDateString }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Approved Date:</Title>
        <Detail>{ status === CONSTANTS.APPROVED ? approvedDateString : '-' }</Detail>
      </GroupLabel>
      <GroupLabel>
        <Title>Submit Remark:</Title>
        <Detail>{ remark || '-' }</Detail>
      </GroupLabel>
    </Wrapper>
  )
}

MyTimesheet.propTypes = {
  myTimesheet: PropTypes.object,
}
MyTimesheet.defaultProps = {
  myTimesheet: {},
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: 10px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 575.98px) {
    display: none;
  }
  @media (max-width: 767.98px) {
    display: none;
  }
`
const GroupLabel = styled.div`
  margin-left: 2%;
`
const Title = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  color: #A9A9A9;
  margin-right: 10px;
  margin-bottom: 0px;
  font-size: 10px;
`
const Detail = styled.span`
  display: flex;
  margin-right: 10px;
  font-size: ${FONTS.SMALL_SIZE};
  color: ${props => props.color};
`
const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 10px;
  width: 10px;
  background-color: ${props => props.color};
  border-radius: 50%;
  margin: 5px;
  margin-left: 0px;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/status-bar/my-timesheet.js